import { render } from "./WCAutoplayCarousel.vue?vue&type=template&id=5024a934&scoped=true"
import script from "./WCAutoplayCarousel.vue?vue&type=script&lang=js"
export * from "./WCAutoplayCarousel.vue?vue&type=script&lang=js"

import "./WCAutoplayCarousel.vue?vue&type=style&index=0&id=5024a934&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5024a934"]])

export default __exports__